/** Small wordings shared by the offline surfaces. */

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** "just now", "12 min ago", "3 h ago", "2 days ago" — short, never precise-looking. */
export function timeAgo(timestamp: number | undefined, now: number = Date.now()): string {
  if (!timestamp) return 'never';
  const delta = Math.max(0, now - timestamp);
  if (delta < MINUTE) return 'just now';
  if (delta < HOUR) return `${Math.floor(delta / MINUTE)} min ago`;
  if (delta < DAY) return `${Math.floor(delta / HOUR)} h ago`;
  const days = Math.floor(delta / DAY);
  return days === 1 ? 'yesterday' : `${days} days ago`;
}

/** "in 45 s", "in 4 min" — when the next attempt is due. */
export function timeUntil(timestamp: number | undefined, now: number = Date.now()): string {
  if (!timestamp) return 'now';
  const delta = timestamp - now;
  if (delta <= 0) return 'now';
  if (delta < MINUTE) return `in ${Math.ceil(delta / 1000)} s`;
  return `in ${Math.ceil(delta / MINUTE)} min`;
}

export function fileSize(bytes: number | undefined): string {
  if (!bytes) return '0 KB';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const plural = (count: number, one: string, many: string): string =>
  `${count} ${count === 1 ? one : many}`;
